module.exports = __webpack_public_path__ + "fonts/Inter-400-cyrillic26.fbe36d9.woff2";